var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page',{attrs:{"footer":"switcher"}},[_c('template',{slot:"pageContent"},[_c('user-consent',{attrs:{"embedded":true,"consent":_vm.consent},on:{"accept":_vm.onAccept,"back":function($event){return _vm.$router.push({name: 'login'})}}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }